import { render } from "./ExcelComp.vue?vue&type=template&id=215711da&scoped=true"
import script from "./ExcelComp.vue?vue&type=script&lang=js"
export * from "./ExcelComp.vue?vue&type=script&lang=js"

import "./ExcelComp.vue?vue&type=style&index=0&id=215711da&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215711da"]])

export default __exports__